export default __webpack_public_path__ + "static/media/img1.6f3af6ac.png";